/** Ask Talkie feature flags from `environment` (build-time). */

import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class SlateConfigService {
    get askTalkieEnabled(): boolean {
        return environment.askTalkieEnabled === true;
    }
}
